import '@shared/types-v0.1.0'

export type InitState = 'shared' | 'navigation' | 'localDb' | 'network' | 'backend' | 'auth' | 'initialized'

const stateMap = new Map<InitState, number>([
	['shared', 0],
	['navigation', 1],
	['localDb', 2],
	['network', 3],
	['backend', 4],
	['auth', 5],
	['initialized', 6],
])

export default async (state: InitState) => {
	return new Promise((resolve) => {
		const interval = setInterval(async () => {
			const target = stateMap.get(state) as number
			const current = stateMap.get(R.states.init.value) as number
			if (current >= target) {
				clearInterval(interval)
				resolve(undefined)
			}
		}, 10)
	})
}
